<template>
  <div class="directional-buttons">
    <el-button plain type="primary" @click="move('up')" icon="el-icon-caret-top" class="direction-btn up"></el-button>
    <el-button plain type="primary" @click="move('down')" icon="el-icon-caret-bottom"
               class="direction-btn down"></el-button>
    <el-button plain type="primary" @click="move('left')" icon="el-icon-caret-left"
               class="direction-btn left"></el-button>
    <el-button plain type="primary" @click="move('right')" icon="el-icon-caret-right"
               class="direction-btn right"></el-button>
    <el-button plain type="danger" @click="move(null)" class="direction-btn pause">停止调整</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    move(direction) {
      this.$emit('move', direction);
    }
  }
};
</script>

<style scoped>
.directional-buttons {
  display: grid;
  grid-template-columns: 70px 70px;
  grid-template-rows: 0 70px;
  justify-items: center;
  align-items: center;
  justify-content: center;
}

.direction-btn {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 0;
  margin: 0;
  transition: background-color 0.3s, transform 0.2s;
}

.direction-btn:hover {
  transform: scale(1.1);
}

.direction-btn:active {
  transform: scale(1.05);
}

.up {
  grid-column: 1 / 3;
  grid-row: 1;
}

.down {
  grid-column: 1 / 3;
  grid-row: 2;
}

.left {
  grid-column: 1;
  grid-row: 2;
}

.right {
  grid-column: 2;
  grid-row: 2;
}

.pause {
  grid-column: 3;
  grid-row: 2;
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/DirectionalButtons.vue